import { render, staticRenderFns } from "./projectCommentTypesList.vue?vue&type=template&id=63cf2888&scoped=true&"
import script from "./projectCommentTypesList.vue?vue&type=script&lang=js&"
export * from "./projectCommentTypesList.vue?vue&type=script&lang=js&"
import style0 from "./projectCommentTypesList.vue?vue&type=style&index=0&id=63cf2888&lang=scss&scoped=true&"
import style1 from "./projectCommentTypesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf2888",
  null
  
)

export default component.exports